// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__M5eri","validationTips":"StatementDescriptor_validationTips__2AFHk"};